import { SupplierBusyPeriod } from "pages/out-of-office/out-of-office.typing";

export const useOutOfOfficeListView = (periods: SupplierBusyPeriod[]) => {
  const isEmpty = periods.length === 0;

  return {
    isEmpty,
    periodCount: periods.length,
  };
};
